import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../util/pageTitles';
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from '../../util/withRouter';
import { Col, Row, Dropdown, DropdownButton, Form, Button } from 'react-bootstrap';
import Confirm from '../../components/Confirm/Confirm';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { getWallboards, deleteWallboard } from './WallboardsActions';
import WallboardConfig from './components/WallboardConfig';
import { setSuccessMessage } from '../App/ErrorsActions';

import { trackWallboardURLCopied } from '../../util/mixpanel';

import pagination from '../../util/pagination';
import throttle from '../../util/throttle';

import Loading from '../../components/Loading/Loading';
import Header from '../../components/Header/Header';

import arrowSortIcon from '../../assets/img/arrow-down.svg';
import { ChartPlaceholder } from '../../components/CardViews/CardViews';
import addIcon from '../../assets/img/createDashboard-icon.svg';
import linkIcon from '../../assets/img/copy.svg';
import deleteIcon from '../../assets/img/delete.svg';
import editIcon from '../../assets/img/edit.svg';

import filterImage from '../../assets/images/filter-icon.svg';

// Import Style
import './Wallboards.scss';

class Wallboards extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      filter: 'all',
      sort: '-createdDate',
      search: '',
      page: 1,
      boards: [],
      sortName: [
        {
          name: 'Name: A to Z',
          value: 'name'
        },
        {
          name: 'Name: Z to A',
          value: '-name'
        }
      ],

      sortCreatedDate: [
        {
          name: 'Created date: newest first',
          value: '-createdDate'
        },
        {
          name: 'Created date: oldest first',
          value: 'createdDate'
        },
      ],

      sortEmail: [
        {
          name: 'Email: A to Z',
          value: 'email'
        },
        {
          name: 'Email: Z to A',
          value: '-email'
        }
      ]
    };

    this.getWallboardsThrottled = throttle(this.getWallboards, 500, this);
  }

  componentDidMount() {
    this.getWallboards();
  }

  applySort = sort => {
    this.setState({ sort, page: 1 }, this.getWallboards);
  };

  getWallboards = () => {
    const { search, sort, page } = this.state;
    const { id } = this.props.routeParams;
    this.props.getWallboards(id, { search, sort, page });
  };

  onSearch = e => {
    this.setState({ search: e.target.value, page: 1 }, this.getWallboardsThrottled);
  };

  onCopy = () => {
    this.props.setSuccessMessage('Wallboard URL copied. This is a public link, anyone with it can view your wallboard without logging in.');
    this.setState({dropdown: null});

    trackWallboardURLCopied();
  }

  goto = page => {
    if (page < 1) {
      page = 1;
    }

    this.setState({ page }, this.getWallboards);
  };

  renderSelected = type => {
    const selected = _.find(this.state[type + 'Options'], {
      value: this.state[type]
    });
    return selected ? selected.name : '';
  };

  toggleFilter = () => {
    document.getElementById('filter-content').classList.toggle('shown');
  };

  onToggle = (i, open) => {
    this.setState({dropdown: {
      i,
      open,
    }})
  }

  isOpen = (i) => {
    return this.state.dropdown && this.state.dropdown.i == i && this.state.dropdown.open;
  }

  renderPagination = () => {
    const pages = pagination(this.props.total, this.props.page, 20, 5);

    if (pages.totalPages < 2) {
      return <div></div>;
    }

    return (
      <ul className="pagination">
        {pages.currentPage > 1 && (
          <li aria-label="First" onClick={() => this.goto(1)}>
            <a role="button" href="#">
              «
            </a>
          </li>
        )}
        {pages.currentPage > 1 && (
          <li aria-label="Prev" onClick={() => this.goto(pages.currentPage - 1)}>
            <a role="button" href="#">
              ‹
            </a>
          </li>
        )}
        {pages.pages.map((p, i) => {
          return (
            <li className={p === pages.currentPage &&  'active'} key={i} onClick={() => this.goto(p)}>
              <a role="button" href="#">
                {p}
              </a>
            </li>
          );
        })}
        {pages.currentPage < pages.totalPages && (
          <li aria-label="Next" onClick={() => this.goto(pages.currentPage + 1)}>
            <a role="button" href="#">
              ›
            </a>
          </li>
        )}
        {pages.currentPage < pages.totalPages && (
          <li aria-label="Last" onClick={() => this.goto(pages.totalPages)}>
            <a role="button" href="#">
              »
            </a>
          </li>
        )}
      </ul>
    );
  };

  render() {
    const { wallboards, isLoading } = this.props;
    const isEmpty = !isLoading && !wallboards.length;

    return [
      <Helmet key="1">
        <title>{pageTitle('Wallboard')}</title>
      </Helmet>,
      <Header key="2" title="" showHome={true} />,
      <React.Fragment key="3">
        <div className='bg_dashboard wallboard_content'>
          <div className="container">
            <WallboardConfig dashboardId={this.props.routeParams.id} onClose={this.getWallboards}>
              <Button variant='primary' className="btn-align-right">
                <img src={addIcon} alt="" />
                Create wallboard
              </Button>
            </WallboardConfig>

            <div className='table-content table-card'>
              <div className='table-filter'>
                <h5>Wallboards</h5>
                {(!isEmpty || !!this.state.search) && (
                  <div className="u-di form-group">
                    <div className='search-wrap'>
                      <input
                        name="search"
                        placeholder="Search"
                        type="text"
                        id="Search"
                        className="form-control"
                        value={this.state.search}
                        onChange={this.onSearch}
                      />
                    </div>
                  </div>
                )}
              {/*<div className='filter-button' onClick={this.toggleFilter}>
                  <img alt="filter" src={filterImage} />
                </div>*/}
              </div>

              {isEmpty && <ChartPlaceholder shape="table" />}
              {!isEmpty && <div className='table-scroll'>
                <table className='table'>
                  <thead>
                    <tr>
                      <th>
                        <div className='flex'>
                          Wallboard name
                          <Form.Group controlId="sort">
                            <DropdownButton
                              className='form-control-dropdown-sort'
                              id="dropdown-item-button"
                              title={<img src={arrowSortIcon} alt="#" />}
                            >
                              {this.state.sortName.map((s, i) => {
                                return (
                                  <Dropdown.Item
                                    key={i}
                                    as="button"
                                    className={this.state.sort === s.value && 'active'}
                                    onClick={() => this.applySort(s.value)}
                                  >
                                    {s.name}
                                  </Dropdown.Item>
                                );
                              })}
                            </DropdownButton>
                          </Form.Group>
                        </div>
                      </th>
                      <th>
                        <div className='flex'>
                          Created by
                          <Form.Group controlId="sort">
                              <DropdownButton
                                className='form-control-dropdown-sort'
                                id="dropdown-item-button"
                                title={<img src={arrowSortIcon} alt="#" />}
                              >
                                {this.state.sortName.map((s, i) => {
                                  return (
                                    <Dropdown.Item
                                      key={i}
                                      as="button"
                                      className={this.state.sort === s.value && 'active'}
                                      onClick={() => this.applySort(s.value)}
                                    >
                                      {s.name}
                                    </Dropdown.Item>
                                  );
                                })}
                              </DropdownButton>
                            </Form.Group>
                        </div>
                      </th>
                      <th>
                        <div className='flex'>
                          Created email
                          <Form.Group controlId="sort">
                            <DropdownButton
                              className='form-control-dropdown-sort'
                              id="dropdown-item-button"
                              title={<img src={arrowSortIcon} alt="#" />}
                            >
                              {this.state.sortEmail.map((s, i) => {
                                return (
                                  <Dropdown.Item
                                    key={i}
                                    as="button"
                                    className={this.state.sort === s.value && 'active'}
                                    onClick={() => this.applySort(s.value)}
                                  >
                                    {s.name}
                                  </Dropdown.Item>
                                );
                              })}
                            </DropdownButton>
                          </Form.Group>
                        </div>
                      </th>
                      <th>
                        <div className='flex'>
                          Created date
                          <Form.Group controlId="sort">
                            <DropdownButton
                              className='form-control-dropdown-sort'
                              id="dropdown-item-button"
                              title={<img src={arrowSortIcon} alt="#" />}
                            >
                              {this.state.sortCreatedDate.map((s, i) => {
                                return (
                                  <Dropdown.Item
                                    key={i}
                                    as="button"
                                    className={this.state.sort === s.value && 'active'}
                                    onClick={() => this.applySort(s.value)}
                                  >
                                    {s.name}
                                  </Dropdown.Item>
                                );
                              })}
                            </DropdownButton>
                          </Form.Group>
                        </div>
                      </th>
                      <th className='width-auto'>
                        Actions
                      </th>
                    </tr>
                  </thead>

                  <tbody>           
                    {wallboards.map((w, i) => {
                      return (
                        <tr key={i}>
                          <td>
                            {w.name}
                          </td>
                          <td>
                            {w.createdBy.name}
                          </td>
                          <td>
                            {w.createdBy.email}
                          </td>
                          <td>
                            {w.createdAt ? moment(w.createdAt).format('D MMM YYYY hh:mm A') : '-'}
                          </td>
                          <td className='width-auto'>
                            <div className='flex'>
                              <CopyToClipboard text={w.shortUrl}
                                onCopy={this.onCopy}>
                                <Button variant='secondary' size='md'>
                                  <img src={linkIcon} alt="" /> Copy link
                                </Button>
                              </CopyToClipboard>
                              <WallboardConfig model={w} dashboardId={this.props.routeParams.id} onClose={this.getWallboards}>
                                <Button variant='secondary' size='md' className='btn-icon' aria-label="Edit"><img src={editIcon} alt="" /></Button>
                              </WallboardConfig>
                              <Confirm
                                  onConfirm={() => this.props.deleteWallboard(this.props.routeParams.id, w._id)}
                                  body={
                                    <p>
                                      Are you sure you want to remove <br />
                                      <strong>{w.name}</strong> wallboard?
                                    </p>
                                  }
                                  confirmText="Remove"
                                  icon={deleteIcon}
                                  title="Remove wallboard"
                                >
                                  <Button variant='danger' className='btn-icon' size='md'><img src={deleteIcon} /></Button>
                                </Confirm>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>}
            </div>
            {this.renderPagination()}
          </div>
        </div>
        {isLoading && (
          <div className='table-loading loader-delay'>
            <Loading />
          </div>
        )}
      </React.Fragment>
    ];
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getWallboards: (dashboardId, opt) => dispatch(getWallboards(dashboardId, opt)),
    deleteWallboard: (dashboardId, wallboardId) => dispatch(deleteWallboard(dashboardId, wallboardId)),
    setSuccessMessage: message => dispatch(setSuccessMessage(message))
  };
};

const mapStateToProps = state => {
  return {
    wallboards: state.wallboards.boards,
    isLoading: state.wallboards.loading,
    page: state.wallboards.page,
    total: state.wallboards.total
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Wallboards));
